<script>
  import router from "page";
  import Home from "./Home.svelte";
  import Bio from "./Bio.svelte";

  let page;

  router("/", () => (page = Home));
  router("/bio", () => (page = Bio));
  router("*", () => router.redirect("/"));

  router.start();
</script>

<svelte:component this={page} />
